// removed by extract-text-webpack-plugin
module.exports = {"title":"ZAuPQPMK18v2W5ja8S5KS","text":"_3--Oi4woV4GviqqwhJt2Ul","edge":"_3KrGQsuqOxfpfPiqMzxw31"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Title/style.scss
// module id = 953
// module chunks = 0